import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import Events from '@/hooks/events';
import actions from '../constants';

const useCloseAnnouncements = (category) => {
  const handler = useDispatch();
  return useCallback(({ date }) => handler({ type: actions.CLOSE_ANNOUNCEMENTS, category, date }), [category]);
};

export default {
  useCloseAnnouncements,
  useNextAnnouncement: () => Events.useSimpleDispatch(actions.NEXT_ANNOUNCEMENT),
  usePreviousAnnouncement: () => Events.useSimpleDispatch(actions.PREVIOUS_ANNOUNCEMENT),
};
